import { MessageCardProps } from "declarations/messages";
import { getTime } from "functions/text";

function RecievedMessageCard({ message, onListingPress }: MessageCardProps) {

  const messageStatus = getTime(message.timestamp || message.createdAt);

  return (
    <div className={ClassName.container}>
      <div className={ClassName.message}>
        <div className={ClassName.content}>
          {(message.carTitle || message.car) && (
            <button
              type="button"
              className={ClassName.tag}
              onClick={() => onListingPress?.(message)}
            >
              {message.carTitle || "View listing"}
            </button>
          )}
          <span className={ClassName.text}>{message.text}</span>
        </div>
        <span className={ClassName.meta}>{messageStatus}</span>
      </div>
    </div>
  );
}

export default RecievedMessageCard;

const ClassName = {
  container: "flex flex-col w-full my-0.5 items-start",
  message:
    "text-[13px] bg-slate-100 dark:bg-slate-800/50 w-fit max-w-[72%] px-4 py-2.5 rounded-2xl rounded-tl-none flex items-end gap-3 border border-slate-200 dark:border-slate-700 shadow-sm",
  content: "flex flex-col gap-1 min-w-0",
  text: "break-words whitespace-pre-wrap leading-5",
  meta: "text-[10px] text-slate-500 flex-shrink-0 whitespace-nowrap",
  tag: "text-slate-700 font-semibold underline underline-offset-2 cursor-pointer bg-transparent border-0 p-0 text-left",
};
